<div class="wrapper__headerComponent container my-5">
  <div class="row">
    <div class="d-flex flex-row align-items-start">
      <img
        src="../../../../assets/img/file-contract.svg"
        alt="logo"
        class="img-ico-form" />
      <h2 class="mb-0">{{ glosarioText['titulo'] }} {{ nombreEntidad }}</h2>
    </div>
  </div>
  <!-- Barra de búsqueda -->
  <div class="row my-3">
    <div class="col-12">
      <div class="d-flex justify-content-center justify-content-md-end">
        <div class="w-100 w-md-75 w-lg-50">
          <div class="govco-search-basic">
            <div class="container-govco d-flex">
              <input
                type="text"
                class="input-search-basic-govco flex-grow-1"
                [placeholder]="glosarioText['buscar']"
                aria-label="buscador"
                [(ngModel)]="buscarTermino"
                (input)="buscarGlosario()" />
              <button
                class="btn-clean-basic-govco me-2"
                type="button"
                id="btn-clean-basic"
                aria-label="Limpiar">
                <span class="govco-svg govco-times"></span>
              </button>
              <div class="line-basic-govco d-none d-md-block"></div>
              <button class="btn-search-basic-govco" type="button"
                aria-label="Buscar">
                <span class="govco-svg govco-search" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Letras del abecedario-->
  <div class="pagination-container-govco">
    <nav class="nav-pagination-govco" aria-label="paginador de ejemplo">
      <div class="pagination-govco" id="paginationExample">
        <ul class="row">
          <li
            style="max-width: 3.5rem"
            [class.active-govco]="filtroActivo === 'Todos'"
            class="col page-item-govco number-govco no">
            <a
              style="width: 3.5rem; border: none;"
              role="button"
              tabindex="0"
              (click)="filtrarGlosario('Todos')"
              (keydown.enter)="filtrarGlosario('Todos')"
              (keydown.space)="filtrarGlosario('Todos')"
              [attr.aria-label]="glosarioText['todos']">
              {{ glosarioText['todos'] }}
            </a>
          </li>
          <li
            *ngFor="let letter of alfabeto"
            [class.active-govco]="filtroActivo === letter"
            class="col page-item-govco number-govco no">
            <a
              style="border: none;"
              role="button"
              tabindex="0"
              (click)="filtrarGlosario(letter)"
              (keydown.enter)="filtrarGlosario(letter)"
              (keydown.space)="filtrarGlosario(letter)"
              [attr.aria-label]="'Filtrar glosario por la letra ' + letter">
              {{ letter }}
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
  <!--Tabla de glosario-->
  <div class="contenedor-tabla w-100">
    <div class="row">
        <div class="d-flex flex-column flex-xl-row align-items-xl-center justify-content-between mt-5">
          <p class="mb-3"></p>
          <div style="margin-left: 5rem; align-items: baseline;">
            <button class="btn-govco outline-btn-govco" (click)="crearNuevaPalabra()"
            aria-label="Crear pregunta">
              {{'glosario.crear_glosario' | translate}}
            </button>
          </div>
        </div>
    <app-table
      [estiloEncabezado]="'height: auto !important;'"
      [datos]="glosario"
      [columnas]="columnas"
      [acciones]="acciones"
      [paginacion]="false"
      (eventoAccion)="editarGlosario($event)">
      </app-table
    >
    </div>
  </div>

  <app-form-editar-glosario (glosarioActualizado)="buscarGlosario()">
  </app-form-editar-glosario>
</div>
